import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getStats = createAsyncThunk(
  "stats/getStats",
  async (undefined, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/order/stats`,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (err) {
      // Handle different types of errors
      if (err.response) {
        // Server responded with error status
        return rejectWithValue(err.response.data);
      } else if (err.request) {
        // Request was made but no response received
        return rejectWithValue({
          message: "Network error - no response from server",
          error: "NETWORK_ERROR",
        });
      } else {
        // Something else happened
        return rejectWithValue({
          message: err.message || "An unexpected error occurred",
          error: "UNKNOWN_ERROR",
        });
      }
    }
  }
);

export const getPrintingStats = createAsyncThunk(
  "stats/getPrintingStats",
  async (filters = {}, { rejectWithValue }) => {
    try {
      // Build query parameters
      const params = new URLSearchParams();

      Object.keys(filters).forEach((key) => {
        if (filters[key] && filters[key].trim() !== "") {
          params.append(key, filters[key]);
        }
      });

      const queryString = params.toString();
      const url = `${process.env.REACT_APP_API_URL}/api/printer-job-details${
        queryString ? `?${queryString}` : ""
      }`;

      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
        },
      });
      return response.data;
    } catch (err) {
      // Handle different types of errors
      if (err.response) {
        // Server responded with error status
        return rejectWithValue(err.response.data);
      } else if (err.request) {
        // Request was made but no response received
        return rejectWithValue({
          message: "Network error - no response from server",
          error: "NETWORK_ERROR",
        });
      } else {
        // Something else happened
        return rejectWithValue({
          message: err.message || "An unexpected error occurred",
          error: "UNKNOWN_ERROR",
        });
      }
    }
  }
);

export default createSlice({
  name: "stats",
  initialState: {
    loading: false,
    counts: {},
    printingStats: null,
    error: null,
  },
  reducers: {},
  extraReducers: {
    [getStats.pending]: (state) => {
      state.loading = true;
      state.counts = {};
      state.error = null;
    },
    [getStats.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.counts = payload;
      state.error = null;
    },
    [getStats.rejected]: (state, action) => {
      state.loading = false;

      // Handle structured error objects or fallback to simple message
      if (action.payload && typeof action.payload === "object") {
        state.error =
          action.payload.message ||
          action.payload.error ||
          "Failed to fetch stats";
      } else {
        state.error =
          action.payload || action.error?.message || "Failed to fetch stats";
      }

      console.error("Stats fetch failed:", action.payload || action.error);
    },
    [getPrintingStats.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getPrintingStats.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.printingStats = payload;
      state.error = null;
    },
    [getPrintingStats.rejected]: (state, action) => {
      state.loading = false;

      // Handle structured error objects or fallback to simple message
      if (action.payload && typeof action.payload === "object") {
        state.error =
          action.payload.message ||
          action.payload.error ||
          "Failed to fetch printing stats";
      } else {
        state.error =
          action.payload ||
          action.error?.message ||
          "Failed to fetch printing stats";
      }

      console.error(
        "Printing stats fetch failed:",
        action.payload || action.error
      );
    },
  },
});
